// @core/api/endpoints/chat/delete_mention_tag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/chat';

/**
 * Delete a mention tag
 * Deletes a custom mention tag from the conversation. All subscriptions to this tag are also removed.
 */
export async function DeleteMentionTag(
  conversation_id: string,
  mention_tag_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/mention-tags/:mention_tag_id`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':mention_tag_id', encodeURIComponent(mention_tag_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
